import styled from "@emotion/styled";
import { StyledTh } from "../../../../styled";

export const TriangleHeaderTh = styled(StyledTh)`
  padding: 0 !important;
  position: relative;
  min-width: 120px;
  height: 100%;
  vertical-align: middle;
  box-sizing: border-box;
  display: table-cell;
`;
